import { Component, input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
    // selector: 'auto',
    template: '<div></div>',
    standalone: false
})

export class AutoSaveComponent implements OnDestroy {

  autoSaveID: any = null;
  lastSave: string = "";
  formReady = false;
  editable = false;
  navDebounce: boolean = false;

  autosave = input.required<any>();

  // constructor() {}

  save(navigate?: boolean) {
    /* parent method */
    console.log("OVERRIDE THIS METHOD")
  }

  checkIfNotNeedToSave(content: any): boolean {
    // No need to save if nothing has changed
    let newSave = JSON.stringify(content)
    if (newSave == this.lastSave) return true
    this.lastSave = newSave

    return false
  }

  postSave() {
    this.autosave().saving = false
    this.autosave().saved = true
    this.autosave().saveTime = new Date()
    this.autosave().updateTimer.next()
  }

  /**
   * Waits for form to change before starting the timeout
   * @param form 
   */
  listenForChanges(form: FormGroup) {
    form.valueChanges.subscribe((value: any) => {
      if (form.touched || this.formReady) {
        this.autosave().saving = true
        this.autosave().saved = false
        this.autoSave()
      }
    })
  }

  ngOnDestroy() {
    // end timeout when we leave the page
    if (this.autoSaveID) {
      clearInterval(this.autoSaveID);
    }
  }

  /**
   * Starts the autosave timeout if he hasn't started yet
   */
  autoSave() {
    if (this.autoSaveID == null) {
      console.log("started autosave...")
      // saving...
      setTimeout(() => {
        this.save();
      }, 1000);
      this.autoSaveID = setInterval(() => {
        this.save();
      }, 5000);
    }
  }

  navDebounceCheck(navigate: boolean | undefined): boolean {
    if (navigate) {
      if (this.navDebounce) return true // Prevent multiple calls of navigate save
      this.navDebounce = false
      this.autosave().saving = false // remove auto save message
      this.autosave().saved = false // remove saved message
    }
    return false
  }
}
